import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana68Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1465_19733)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("19"))}
      d="M335.717 796.418L402.33 745.884L363.281 728.656L335.717 796.418Z" 
      fill={getFillByLot(19, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("18"))}
      d="M321.933 806.753L335.715 796.416L341.458 781.486L300.112 763.109L286.33 797.565C291.842 808.59 312.362 808.284 321.933 806.753Z" 
      fill={getFillByLot(18, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("17"))}
      d="M313.892 729.805L300.11 763.111L341.457 781.488L355.239 748.181L313.892 729.805Z" 
      fill={getFillByLot(17, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("16"))}
      d="M327.677 696.498L313.895 729.805L355.241 748.181L369.023 714.874L327.677 696.498Z" 
      fill={getFillByLot(16, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("20"))}
      d="M408.069 741.298L402.327 745.892L363.277 728.664L377.059 695.357L419.554 714.882L408.069 741.298Z" 
      fill={getFillByLot(20, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("21"))}
      d="M433.337 681.57L419.554 714.876L377.06 695.352L390.842 663.193L433.337 681.57Z" 
      fill={getFillByLot(21, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("15"))}
      d="M341.459 663.193L327.677 696.5L369.024 714.876L382.806 681.57L341.459 663.193Z" 
      fill={getFillByLot(15, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("14"))}
      d="M355.241 631.035L341.458 663.193L382.805 681.57L396.587 649.411L355.241 631.035Z" 
      fill={getFillByLot(14, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("22"))}
      d="M447.12 649.411L433.338 681.57L390.843 663.193L404.625 631.035L447.12 649.411Z" 
      fill={getFillByLot(22, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("13"))}
      d="M369.024 596.58L355.242 631.035L396.588 649.411L410.37 614.956L369.024 596.58Z" 
      fill={getFillByLot(13, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("23"))}
      d="M460.902 617.255L447.12 649.413L404.625 631.037L417.259 597.73L460.902 617.255Z" 
      fill={getFillByLot(23, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("24"))}
      d="M473.537 585.099L460.904 617.257L417.26 597.732L431.042 565.574L473.537 585.099Z" 
      fill={getFillByLot(24, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("25"))}
      d="M487.319 550.64L473.537 585.095L431.042 565.57L444.825 532.264L487.319 550.64Z" 
      fill={getFillByLot(25, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("26"))}
      d="M499.954 518.484L487.321 550.642L444.826 532.266L457.459 500.107L499.954 518.484Z" 
      fill={getFillByLot(26, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("12"))}
      d="M382.805 563.271L369.023 596.578L410.369 614.954L424.151 580.499L382.805 563.271Z" 
      fill={getFillByLot(12, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("11"))}
      d="M396.583 529.971L382.801 563.277L424.148 580.505L437.93 548.347L396.583 529.971Z" 
      fill={getFillByLot(11, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))}
      d="M410.367 496.66L396.584 529.967L437.931 548.343L451.713 513.888L410.367 496.66Z" 
      fill={getFillByLot(10, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))}
      d="M424.149 463.35L410.367 496.656L451.713 513.884L465.495 480.577L424.149 463.35Z" 
      fill={getFillByLot(9, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))}
      d="M437.931 430.043L424.149 463.35L465.495 480.577L479.277 447.271L437.931 430.043Z" 
      fill={getFillByLot(8, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("27"))}
      d="M513.732 486.325L499.95 518.484L457.455 500.107L471.237 467.949L513.732 486.325Z" 
      fill={getFillByLot(27, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("28"))}
      d="M527.514 453.017L513.732 486.324L471.237 467.947L485.019 434.641L527.514 453.017Z" 
      fill={getFillByLot(28, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("29"))}
      d="M541.3 420.861L527.518 453.019L485.023 434.643L498.806 402.484L541.3 420.861Z" 
      fill={getFillByLot(29, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))}
      d="M452.861 395.594L437.931 430.049L479.277 447.277L494.208 412.821L452.861 395.594Z" 
      fill={getFillByLot(7, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))}
      d="M465.498 363.432L452.865 395.59L494.211 412.818L506.845 380.659L465.498 363.432Z" 
      fill={getFillByLot(6, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("30"))}
      d="M555.083 388.7L541.301 420.859L498.806 402.482L511.44 370.324L555.083 388.7Z" 
      fill={getFillByLot(30, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("31"))}
      d="M568.865 356.542L555.083 388.7L512.588 370.324L525.222 338.166L568.865 356.542Z" 
      fill={getFillByLot(31, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("32"))}
      d="M581.497 324.382L568.863 356.54L525.22 338.164L539.002 304.857L581.497 324.382Z" 
      fill={getFillByLot(32, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("33"))}
      d="M595.278 291.075L581.496 324.382L539.001 304.858L551.635 271.551L595.278 291.075Z" 
      fill={getFillByLot(33, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))}
      d="M479.278 330.129L465.496 363.436L507.991 380.663L520.625 347.357L479.278 330.129Z" 
      fill={getFillByLot(5, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))}
      d="M494.208 296.818L479.278 330.125L520.624 348.501L535.555 314.046L494.208 296.818Z" 
      fill={getFillByLot(4, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))}
      d="M507.995 263.518L494.213 296.824L535.559 314.052L548.193 280.745L507.995 263.518Z" 
      fill={getFillByLot(3, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("34"))}
      d="M565.42 239.395L551.638 271.553L595.282 291.077L607.915 258.919L565.42 239.395Z" 
      fill={getFillByLot(34, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("35"))}
      d="M621.696 225.614L607.914 258.921L565.419 239.397L579.201 207.238L621.696 225.614Z" 
      fill={getFillByLot(35, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("36"))}
      d="M636.627 192.304L621.696 225.611L579.202 207.235L584.944 193.453L622.845 178.522C636.627 176.685 637.776 186.945 636.627 192.304Z" 
      fill={getFillByLot(36, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))}
      d="M521.773 229.057L507.991 263.512L548.189 280.74L561.971 247.433L521.773 229.057Z" 
      fill={getFillByLot(2, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M526.366 217.57L521.772 229.055L561.97 247.431L584.94 193.451L526.366 217.57Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1465_19733" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1465_19733" transform="matrix(0.00157537 0 0 0.00208852 -2.36446 -1.64849)"/>
    </pattern>
    <image id="image0_1465_19733" width="4096" height="2304" href="/mz2.png"/>
        </defs>
</svg>

  );
};
